module.exports = __webpack_public_path__ + "static/media/bg1.c21dfe7f.jpeg";